<template>
    <div>
        <slot
            :brief="brief"
            :order="order"
            :products="products"
            :is-loading="isLoading"
        />
    </div>
</template>

<script>
    import { get } from 'lodash';
    import ActivationBriefMixin from '../mixins/ActivationBriefMixin';
    import ContactsMixin from '../mixins/ContactsMixin';
    import ActivationBriefProductsMixin from '../mixins/ActivationBriefProductsMixin';

    export default {
        name: 'ActivationBriefOrderProvider',
        mixins: [
            ActivationBriefMixin,
            ActivationBriefProductsMixin,
            ContactsMixin,
        ],
        data() {
            return {
                isLoading: false,
                order: null,
                products: [],
            };
        },
        computed: {
            orders() {
                return get(this, 'brief.orders', []);
            }
        },
        methods: {
            loadOrder(orderId) {
                this.order = this.orders.find(order => String(order.id) === String(orderId));

                if (!this.order) {
                    console.log("Could not find order " + orderId);
                    return;
                }

                return this.getProducts(this.order.items.map(item => item.product_id))
                    .then(products => {
                        this.order.products = products;
                        this.products = products;
                    });
            }
        },
        created() {
            this.isLoading = true;

            this.loadContact()
                .then(() => {
                    return Promise.all([
                        this.loadActivationBrief(),
                    ]);
                })
                .then(() => this.loadOrder(this.$route.params.order_id))
                .catch((error) => console.log(error))
                .then(() => {
                    this.isLoading = false;
                });
        },
    };
</script>
